import { render } from "./OrderTatalPoints.vue?vue&type=template&id=4b0bf4a4&scoped=true"
import script from "./OrderTatalPoints.vue?vue&type=script&lang=js"
export * from "./OrderTatalPoints.vue?vue&type=script&lang=js"

import "./OrderTatalPoints.vue?vue&type=style&index=0&id=4b0bf4a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b0bf4a4"]])

export default __exports__